import useAppSelector from "../hooks/useAppSelector";
import ImageWithFallback from "./atoms/ImageWithFallback";
import Loader from "./atoms/Loader";

const CruiseHeaderImage = () => {
  const cruiseHeaderImage = useAppSelector(
    (state) => state.cruises.cruiseHeaderImage
  );

  if (cruiseHeaderImage === "") {
    return <Loader />;
  }

  return (
    <div className="container-2-1 md:full-height-container xl:container-2-1">
      <ImageWithFallback
        className="container-2-1-img md:full-height-container-img xl:container-2-1-img cover-fit"
        alt="cruise header"
        src={cruiseHeaderImage}
      />
    </div>
  );
};

export default CruiseHeaderImage;
